module.exports = __webpack_public_path__ + "img/dashboard-icon.209a9593.svg";